<template>
  <div class="card-body">
    <h4 id="header-inventory" class="card-title card-collapse ">
      <span
        class="pointer"
        @click="
          inventoryComponentModel.collapseState = !inventoryComponentModel.collapseState
        "
        >Inventory</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="inventoryComponentModel.validateState == false"
          @click="
            inventoryComponentModel.collapseState = !inventoryComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            inventoryComponentModel.collapseState = !inventoryComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="inventoryComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-inventory"
      v-model="inventoryComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>

              <div class="form-row form-group">
                <label class="col-lg-4 col-xl-3 col-form-label" for="warehouse"
                  >คลังสินค้า</label
                >
                <div class="col-sm-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="warehouse"
                    :rules="{
                      validateWarehouseSelector: true,
                      dynamicRequired: ['กรุณาเลือกคลังสินค้า'],
                    }"
                  >
                    <multiselect
                      v-model="
                        inventoryComponentModel.model
                          .warehouse_for_goods_received
                      "
                      :options="warehouseSelectorOptions"
                      :custom-label="
                        label => (label ? label.warehouse_name : '')
                      "
                      :show-labels="false"
                      :allowEmpty="true"
                      :class="{ 'is-invalid': errors && errors.length }"
                      :disabled="
                        dataPermissions.find(f => f.name === 'inventory')
                          .isEditable === false
                      "
                      placeholder="เลือกคลังสินค้า"
                    >
                      <template slot="placeholder">
                        <span>เลือกคลังสินค้า</span>
                      </template>
                    </multiselect>
                    <span
                      v-if="errors && errors.length > 0"
                      class="validate-invalid"
                    >
                      {{ errors[0] }}
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div
                class="form-row form-group"
                v-if="
                  inventoryComponentModel.model.warehouse_for_goods_received &&
                    inventoryComponentModel.model.warehouse_for_goods_received
                      .warehouse_id !== ''
                "
              >
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="subwarehouse"
                  >คลังสินค้าย่อย</label
                >
                <div class="col-sm-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="subwarehouse"
                    :rules="{
                      validateSubWarehouseSelector: true,
                      dynamicRequired: ['กรุณาเลือกคลังสินค้าย่อย'],
                    }"
                  >
                    <multiselect
                      v-model="
                        inventoryComponentModel.model
                          .warehouse_for_goods_received.sub_warehouses
                      "
                      :options="subWarehouseSelectorOptions"
                      :custom-label="
                        label => (label ? label.sub_warehouse_name : '')
                      "
                      :show-labels="false"
                      :allowEmpty="true"
                      :class="{ 'is-invalid': errors && errors.length }"
                      :disabled="
                        inventoryComponentModel.model
                          .warehouse_for_goods_received.warehouse_id === '' ||
                          dataPermissions.find(f => f.name === 'inventory')
                            .isEditable === false
                      "
                      placeholder="เลือกคลังสินค้าย่อย"
                    />
                    <span
                      v-if="errors && errors.length > 0"
                      class="validate-invalid"
                    >
                      {{ errors[0] }}
                    </span>
                  </validationProvider>
                </div>
              </div>
              <div class="form-row form-group" v-else>
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="subwarehouse"
                  >คลังสินค้าย่อย</label
                >
                <div class="col-sm-4">
                  <multiselect
                    :options="subWarehouseSelectorOptions"
                    disabled
                    placeholder="เลือกคลังสินค้าย่อย"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12"></div>
          </div>
        </div>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import warehouseService from '@/helpers/service/warehouse-service'
import Multiselect from 'vue-multiselect'
import { eventBus } from '@/main.js'
export default {
  name: 'Inventory',
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.inventoryComponentModel
      },
    },
    vendor_type: {
      type: String,
      default: '',
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      // inventoryComponentModel: {
      //   collapseState: false,
      //   validateState: false,
      //   isPayloadChanged: false,
      //   model: {
      //     warehouse_for_goods_received: {
      //       warehouse_id: '',
      //       warehouse_name: '',
      //       sub_warehouses: {
      //         sub_warehouse_id: '',
      //         sub_warehouse_name: '',
      //         order_type: '',
      //       },
      //     },
      //   },
      // },
      inventoryComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          warehouse_for_goods_received: null,
        },
      },
      warehouseOptions: [],
      isReload: false,
      permissions: [
        {
          name: 'inventory',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
    }
  },
  created() {
    this.onGetWarehouseItemsSelector()
    eventBus.$on('collapse-inventory', text => {
      this.inventoryComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
    warehouseSelectorOptions() {
      let options = []
      if (this.warehouseOptions && this.warehouseOptions.length > 0) {
        options = this.warehouseOptions
        if (this.vendor_type !== 'OFMStock') {
          options = options
            .filter(f => f.sub_warehouses.some(s => s.order_type === 'MKP'))
            .map(m => {
              return {
                warehouse_id: m.warehouse_id,
                warehouse_name: m.warehouse_name,
                sub_warehouses: null,
              }
            })
        } else {
          options = options
            .filter(f => f.sub_warehouses.some(s => s.order_type !== 'MKP'))
            .map(m => {
              return {
                warehouse_id: m.warehouse_id,
                warehouse_name: m.warehouse_name,
                sub_warehouses: null,
              }
            })
        }
      }
      return options
    },
    subWarehouseSelectorOptions() {
      let options = []
      if (
        this.warehouseOptions &&
        this.warehouseOptions.length > 0 &&
        this.inventoryComponentModel.model.warehouse_for_goods_received &&
        this.inventoryComponentModel.model.warehouse_for_goods_received
          .warehouse_id &&
        this.inventoryComponentModel.model.warehouse_for_goods_received
          .warehouse_id !== ''
      ) {
        options = this.warehouseOptions.some(
          f =>
            f.warehouse_id ===
            this.inventoryComponentModel.model.warehouse_for_goods_received
              .warehouse_id
        )
          ? this.warehouseOptions.find(
              f =>
                f.warehouse_id ===
                this.inventoryComponentModel.model.warehouse_for_goods_received
                  .warehouse_id
            ).sub_warehouses
          : []
        if (options && options.length > 0) {
          if (this.vendor_type !== 'OFMStock') {
            options = options.filter(f => f.order_type === 'MKP')
          } else {
            options = options.filter(f => f.order_type !== 'MKP')
          }
        }
      }
      return options
    },
  },
  watch: {
    'inventoryComponentModel.model': {
      handler(val) {
        this.onSubmit()
      },
      deep: true,
    },
    value: {
      handler(val) {
        this.inventoryComponentModel = val
        this.$nextTick(() => {
          this.onSubmit()
        })
      },
      deep: true,
    },
  },
  methods: {
    modelChanged() {
      this.inventoryComponentModel.isPayloadChanged = true
      this.$emit('input', this.inventoryComponentModel)
    },
    onSubmit() {
      this.$refs.componentForm.validate().then(result => {
        if (result) {
          this.inventoryComponentModel.validateState = true
        } else {
          this.inventoryComponentModel.validateState = false
        }
        this.modelChanged()
      })
    },
    onReset() {
      this.isReload = true
    },
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
    async onGetWarehouseItemsSelector() {
      let params = new URLSearchParams()
      params.append('pageSize', 999999)
      params.append('sort', 'warehouse_name')
      let result = await warehouseService.getWarehouseListAsync(params)
      if (result.status === 200) {
        let warehouseItems = []
        result.data.items.forEach((element, index) => {
          warehouseItems[index] = {
            warehouse_id: element.id,
            warehouse_name: element.warehouse_name,
            sub_warehouses: element.sub_warehouses,
          }
        })
        this.warehouseOptions = warehouseItems
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        } else {
          console.log('Bad request: Unkonw error')
        }
      }
    },
  },
}
</script>
